function UpdateContactInfo(customer, dataChanged) {
  const self = this

  let countries = [];
  let cities = [];
  let modal = $('#updateContactInfo');

  self.init = function() {
    Fetch.get('/counties').then(function(response) {
      countries = response['countries']
      countries.unshift({name: '', code: ''})
    });

    Fetch.get('/cities').then(function(response) {
      cities = response['cities']
      cities.unshift({name: '', code: ''})
    });

    modal.on('click', '#updateInfo', updateContactInfo)
    modal.on('shown.bs.modal', fillContactData)
    checkAndFillUserData()
  }

  function checkAndFillUserData() {
    $.post('/customer-validate', {
      email: customer.email,
      phone: customer.phone,
      country: customer.address.country,
      languagePreference: getLanguagePreference(customer)
    })
      .fail(function () {
        modal.modal('show')
      })
  }

  function updateContactInfo(e) {
    e.preventDefault()
    $("div").removeClass("has-danger");

    let customerData = {
      email: modal.find('form [name=email]').val(),
      phone: modal.find('form [name=phone]').val(),
      country: modal.find('form [name=country]').val(),
      extractFlag: modal.find('form [name=extractFlag]').is(':checked'),
      languagePreference: modal.find('form [name=languagePreference]:checked').val(),
    }
    $.post('/customer', customerData)
      .done(function (response) {
        window.session.setCustomer(response.customer)
        if (dataChanged) dataChanged()
        modal.modal('hide')
      })
      .fail(function (xhr) {
        Object.entries(xhr.responseJSON.validationErrors).forEach(function(k) {
          modal.find('form [name=' + k[0] + ']').closest('div').addClass('has-danger')
        });
      })

  }

  function fillContactData() {
    let customer = session.customer
    $("div").removeClass("has-danger");

    $(countries).each(function(i, country) {
      modal.find('form [name=country]').append('<option value="' + country.code + '" >' + country.name + '</option>')
    });

    $(cities).each(function(i, city) {
      modal.find('form [name=city]').append('<option value="' + city.code + '" >' + city.name + '</option>')
    });

    modal.find('form [name=firstName]').val(customer.firstName)
    modal.find('form [name=lastName]').val(customer.lastName)
    modal.find('form [name=personalCode]').val(customer.personalCode.personalCode)
    modal.find('form [name=email]').val(customer.email)
    modal.find('form [name=phone]').val(customer.phone)

    let languagePreference = getLanguagePreference(customer)
    modal.find('form [name=extractFlag]').prop("checked", customer.extractFlag.isEnabled)
    modal.find('form [name=languagePreference][value=' + languagePreference + ']').prop("checked", true)
    modal.find('form [name=country]').val(customer.address.country)
    modal.find('form [name=country]').change()
  }
}

function getLanguagePreference(customer) {
  return customer.languagePreference.inEstonian ? "EST" : customer.languagePreference.inRussian ? "RUS" : "ENG"
}